import React, { useState, useEffect, useContext } from "react";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";
import "./questionsList.css";
import ViewIcon from "@mui/icons-material/Visibility";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import {
  NotificationContainer,
} from "react-notifications";
import testQuestionDescription from "../../utilities/questionSyntaxHighlight";
import getAllTests from "../../apis/Tests/getAllTests";
import getQuestionBytestIdResponse from "../../apis/question/getQuestionByTestId";
import getQuestionBySubSKillIdResponse from "../../apis/question/getQuestionBySubSkillId"
import { UserTypeContext } from "../../AppRoute";
import getSubskills from "../../apis/Tests/getSubskills";
import VirtualizedBox from "../../components/VirtualizedList/VirtualizedBox";
import DataTable from "../../components/DataTable/DataTable";
import AutoComplete from "../../components/AutoComplete/AutoComplete";
import Tooltip from "@mui/material/Tooltip";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
const filterSkillOptions = createFilterOptions({
  matchFrom: "start",
  stringify: (option) => option.testName,
});

const filterSubSkillOptions = createFilterOptions({
  matchFrom: "start",
  stringify: (option) => option.name,
});
const stylesSx = {
  bodyForSupport: {
    padding: '0px 30px !important',
  },
  buttonForSupport: {
    justifyContent: 'flex-end !important',
    padding: '25px 42px 30px !important',
  },
  title: {
    padding: '16px 30px !important',
  },
  bodyForShare: {
    padding: '0px 30px !important',
  },
  fontRoboto: {
    fontFamily: 'Roboto, sans-serif',
  },
  hK: {
    height: '320px',
  },
};
const QuestionsList = ({ idContextTest }) => {
  const { userType } = useContext(UserTypeContext);
  const history = useNavigate();
  const [questionsList, setQuestionsList] = useState([]);
  const [questionDialogOpen, setQuestionDialogOpen] = useState(false);
  const [questionDialogModalValue, setQuestionDialogModalValue] = useState({});
  const [subSkillsList, setSubSkillsList] = useState([]);
  const [testList, settestList] = useState([]);
  const [loadingController, setLoadingController] = useState(false);
  const [testId, setTestId] = useState('');
  const [subSkillId, setSubSkillId] = useState('');
  const [disable, setDisable] = useState({ testDropDown: false, subSkillDropDown: false });
  const [noRecordMessage, setNoRecordMessage] = useState("No records available");
  useEffect(() => {

    (async () => {
      try {

        const allTestData = await getAllTests();
        if (allTestData.status === 200) {

          settestList(allTestData.data.data);


        }
        const allSubSkillData = await getSubskills();
        if (allSubSkillData.status === 200) {
          setSubSkillsList(allSubSkillData.data.data);
        }

      } catch (error) {
        setLoadingController(true)
      } finally {
        setLoadingController(true)
      }

    })()

  }, []);

  const addQuestions = () => {
    history("/addquestion");
  };
  const viewDialogOpen = (list) => {
    setQuestionDialogOpen(true);
    setQuestionDialogModalValue(list);
  };
  const viewDialogClose = () => {
    setQuestionDialogOpen(false);
  };
  const getQuestionBySkill = async (id, selectedDropdown) => {
    if (id) {
      try {
        let skillChangeData = [];
        if (selectedDropdown === "test") {
          setTestId(id);
          skillChangeData = await getQuestionBytestIdResponse(id);
        } else if (selectedDropdown === "subSkill") {
          setSubSkillId(id);
          skillChangeData = await getQuestionBySubSKillIdResponse(id);
        }

        let arr = [];
        setQuestionsList(skillChangeData.data.data);
        let skillChangeDataArr = skillChangeData?.data?.data;

        if (skillChangeDataArr.length > 0) {
          for (let i = 0; i < skillChangeDataArr.length; i++) {
            arr.push(Object.assign(skillChangeDataArr[i], {
              Id: i + 1,
            }));
          }
        } else {
          if (selectedDropdown === "test") {
            setNoRecordMessage("No record available for selected test")
          } else if (selectedDropdown === "subSkill") {
            setNoRecordMessage("No record available for selected sub skill")
          }
        }

      } catch (err) {
        console.error(err);
      }
    }
  }

  const skillChangeHandler = async (e, value) => {

    if (value) {
      setDisable({ testDropDown: false, subSkillDropDown: true })
      getQuestionBySkill(value.id, "test");
    } else {
      setDisable({ testDropDown: false, subSkillDropDown: false });
      // setDataResult(process([], data));
      setNoRecordMessage("No records available")
    }
  };


  const subSkillChangeHandler = async (e, value) => {
    if (value) {
      setDisable({ testDropDown: true, subSkillDropDown: false });
      getQuestionBySkill(value.id, "subSkill");
    } else {
      setDisable({ testDropDown: false, subSkillDropDown: false });
      // setDataResult(process([], data));
      setNoRecordMessage("No records available")
    }
  }
  const handleQuestion = (props) => {
    return <td>{testQuestionDescription(props.dataItem.questionDesc)}</td>;
  };

  // setTimeout(() => Prism.highlightAll(), 0);

  const newFunc = (event) => {
    var arr = questionsList.filter((item, i) => item.isActive === true);
    history(`${event}`,
      {
        state: {
          testId: testId,
          subSkillId: subSkillId,
          numberOfQuestionsArr: arr,
        }
      });
  }
  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]


  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    const activityOptions = [
      { label: 'All', value: '' },
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  let columns = [
    {
      accessorKey: "Id",
      header: "Id",
      size: 100,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "questionDesc",
      header: "Question",
      size: 500,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      id: "edit",
      header: "Action",
      cell: ({ row }) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => newFunc(row.original.id)}
          className="editBtn_recruiterPrivateSkillAccess"
        >
          Edit
        </Button>
      ),
      size: 180,
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      id: "View",
      header: "View",
      cell: ({ row }) => (
        <td>
          <ViewIcon
            className="cursorChange"
            onClick={() => viewDialogOpen(row.original)}
          />
        </td>
      ),
      size: 50,
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 80,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <AutoComplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
  ]

  const goToDashboard = () => {
    history("/admin-home");
  };

  return (
    <>
      <div className="section-wrapper">
        <div className="tcContainer container w1200 flex-to-footer">
          <div className="height_adjust">
            {!loadingController ? (
              <div className="row circular-progress-center-question text-center">
                <CircularProgress />
              </div>
            ) : (
              <>
                {userType === "Admin" ? (
                  <>
                    <div className="question-list-section-wrapper">
                      <div className="communityHeader_manageUser ">
                        <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                          <Tooltip title="Go Back to Dashboard" placement="bottom">
                            <ArrowBackIcon sx={{ fontSize: 20 }} />
                          </Tooltip>
                        </div>
                        <div className="communityTitle">Questions</div>
                      </div>

                      <div className="subkill-filter-question subkill-filter-question-addquestion">
                        <div className="subkill-filter-question-wrapper">

                          <label className="field_name" htmlFor="country">
                            Tests*
                          </label>
                          <Autocomplete
                            id="combo-box-demo"
                            className="mt_9"
                            options={testList}
                            autoHighlight
                            filterOptions={filterSkillOptions}
                            autoSelect
                            disabled={disable.testDropDown}
                            getOptionLabel={(option) => option.testName}
                            onChange={skillChangeHandler}
                            ListboxComponent={VirtualizedBox} // Use a custom listbox component
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                required
                                placeholder="Select a test"
                              />
                            )}
                          />
                        </div>
                        <div className="subkill-filter-question-wrapper">

                          <label className="field_name" htmlFor="country">
                            Sub Skills*
                          </label>
                          <Autocomplete
                            id="combo-box-demo"
                            className="mt_9"
                            options={subSkillsList}
                            autoHighlight
                            filterOptions={filterSubSkillOptions}
                            autoSelect
                            disabled={disable.subSkillDropDown}
                            getOptionLabel={(option) => option.name}
                            onChange={subSkillChangeHandler}
                            ListboxComponent={VirtualizedBox} // Use a custom listbox component
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                required
                                placeholder="Select a Sub Skill"
                              />
                            )}
                          />
                        </div>
                        <button
                          className="btn_question btn_primary cp mt_24"
                          onClick={() => addQuestions()}
                        >
                          Add Question
                        </button>
                      </div>

                      <DataTable
                        data={questionsList}
                        columns={columns}
                        isLoading={!loadingController}
                        initialColumnFilters={[
                          {
                            id: 'isActive',
                            value: 'true'
                          }
                        ]}
                      />
                    </div>
                  </>
                ) : userType === "" ? (
                  <div className="row padding_80 text-center">
                    <p className="fs-semi-bold fs-40 f-color">
                      Loading...
                    </p>
                  </div>) : (
                   <UnauthorizedAccess />
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <>
        <Dialog
          open={questionDialogOpen}
          onClose={viewDialogClose}
          aria-labelledby="form-dialog-title"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogTitle
            id="form-dialog-title"
            className="responsive_title"
            sx={stylesSx.title}
          >
            {/* Answer Set */}
          </DialogTitle>
          <div className="answer-set-container">
            {/* <h2> Question Render</h2> */}
            <span className="fs-semi-ui-class fs-18 f-color mb_12">
              {testQuestionDescription(questionDialogModalValue.questionDesc)}
            </span>
            {questionDialogModalValue &&
              questionDialogModalValue.questionAnswer?.map((item, index) => (
                <div className="answer-set-list mb_12" key={"ans_" + index}>
                  {/* <span key={index}></span> */}
                  <FormControlLabel
                    value="disabled"
                    disabled
                    control={<Radio />}
                  />
                  <span className="fs-regular fs-16 f-color" dangerouslySetInnerHTML={{
                    __html: item.answerText
                  }}>
                    {/* {item.answerText} */}
                  </span>
                  <span className="ml_17">
                    {item.isCorrect && (
                      <>
                        {/* <img src = {correct} alt='correct'/> */}
                        <span className="fs-semi-bold fs-16 f-color correct-answer-layout">
                          Correct
                        </span>
                      </>
                    )}
                  </span>
                </div>
              ))}
            <Divider />
            <h2> Question Details</h2>
            <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}>
                <Typography gutterBottom>Subject Matter Expert:</Typography>
                <Typography gutterBottom>Created At:</Typography>
                <Typography gutterBottom>Updated At:</Typography>
              </Grid>
              <Grid size={{ xs: 7 }}>
                <Typography gutterBottom>
                  {" "}
                  {questionDialogModalValue.subjectMatterExpert ||
                    "SME Not Specified"}{" "}
                </Typography>
                {questionDialogModalValue?.createdAt ? (
                  <>
                    <Typography gutterBottom>
                      {new Intl.DateTimeFormat("en", { month: "long" }).format(
                        new Date(questionDialogModalValue?.createdAt)
                      ) +
                        "-" +
                        new Intl.DateTimeFormat("en", {
                          day: "2-digit",
                        }).format(
                          new Date(questionDialogModalValue?.createdAt)
                        ) +
                        "-" +
                        new Intl.DateTimeFormat("en", {
                          year: "numeric",
                        }).format(
                          new Date(questionDialogModalValue?.createdAt)
                        ) +
                        " " +
                        new Intl.DateTimeFormat("en", {
                          hour: "numeric",
                          minute: "numeric",
                        }).format(
                          new Date(questionDialogModalValue?.createdAt)
                        )}
                    </Typography>
                    <Typography gutterBottom>
                      {new Intl.DateTimeFormat("en", { month: "long" }).format(
                        new Date(questionDialogModalValue.updatedAt)
                      ) +
                        "-" +
                        new Intl.DateTimeFormat("en", {
                          day: "2-digit",
                        }).format(
                          new Date(questionDialogModalValue.updatedAt)
                        ) +
                        "-" +
                        new Intl.DateTimeFormat("en", {
                          year: "numeric",
                        }).format(
                          new Date(questionDialogModalValue.updatedAt)
                        ) +
                        " " +
                        new Intl.DateTimeFormat("en", {
                          hour: "numeric",
                          minute: "numeric",
                        }).format(new Date(questionDialogModalValue.updatedAt))}
                    </Typography>
                  </>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </div>
          <DialogContent
            className="responsive_Support"
            sx={stylesSx.bodyForSupport}
          ></DialogContent>

          <DialogActions sx={stylesSx.buttonForSupport}>
            <button
              type="button"
              className="btn-big btn-skill cp"
              onClick={() => viewDialogClose()}
            >
              Close
            </button>
          </DialogActions>
        </Dialog>
      </>
      <NotificationContainer />
    </>
  );
};
export default QuestionsList;
